import React from "react";
import "./TrustBar.scss";

const TrustBar = () => {
  const items = [
    {
      title: "Cobertura nacional",
      text: "Envíos a todo México",
    },
    {
      title: "Atención profesional",
      text: "Asesoría personalizada",
    },
    {
      title: "Maquinaria industrial",
      text: "Equipos para alta productividad",
    },
    {
      title: "Entrega flexible",
      text: "Recoge con nosotros o recibe en tu empresa",
    },
  ];

  return (
    <section className="trustbar">
      <div className="container">
        <div className="trustbar__wrapper">
          {items.map((item, index) => (
            <div className="trustbar__item" key={index}>
              <div className="trustbar__icon">
                <span></span>
              </div>

              <div className="trustbar__content">
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;